import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../../../vars/breakpoints';
/* import gutters from '../../../vars/gutters'; */
import colors from '../../../vars/colors';

export const TickerWrapper = styled.div`
    font-size: 80px;
    font-family: 'OneDotCd', sans-serif;
    font-weight: bold;
    color: ${colors['lipstick']};        
    line-height: 1;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    @media (max-width: ${breakpoints['bp-desktop']}) {
        font-size: 60px;
    }
    > span {
        display: flex;
    }
    .dialWrapper, .comma {
        display: inline-block;
        height: 69px;
        overflow: hidden;
        position: relative;
        opacity: ${props => props.active ? '1' : '0'};
        @media (max-width: ${breakpoints['bp-desktop']}) {
            height: 52px;
            transform: translate(0, 1px);
        }
    }
    &.active {
        .dial {
            transform: translate3d(0, 0, 0);
        }
    }
    .dial {
        display: inline-block;
        transition-property: transform;
        transition-timing-function: linear;
        transform: translate3d(0, -100%, 0);
    }
    @keyframes dialanimation {
        0% {transform: translate3d(0, calc(-100% * ( 10/11 )), 0)}
        100% {transform: translate3d(0, 0, 0)}
    }
    .fullText {
        text-align: center;
        display: inline-block;
        text-transform: uppercase;
        .label {
            color: ${colors['peacock-blue']};
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            .number {
                display: block;
            }
            .label {
                font-size: 42px;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/modules/Ticker/styled-components.js